import { ALL_ROUTES } from '@hotjar/webapp/constants/routes';
import type { RouteConfig } from './types';

export function findRouteConfig(matcher: (route: RouteConfig) => boolean): RouteConfig | undefined {
  return ALL_ROUTES.find((route) => matcher(route));
}
